module.exports = __webpack_public_path__ + "img/circle-check-subscribtion-plan-new.20ca248c.svg";